import { useJsApiLoader } from "@react-google-maps/api";
const libraries = ["visualization", "drawing"];

export function useGoogleMapsLoading() {
	const { isLoaded } = useJsApiLoader({
		id: "google-map-script",
		googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_KEY,
		libraries: libraries,
	});
	return { isLoaded };
}
